import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-elapsedticket-time',
    templateUrl: './elapsedticket-time.component.html',
    styleUrls: ['./elapsedticket-time.component.css'],
    standalone: false
})
export class ElapsedticketTimeComponent implements OnInit {


  @Input() starttime: any;
  @Input() endtime: any;
  @Input() title: string;
  @Input() img_url: string;
  @Input() timerstop: EventEmitter<boolean>;
  pastTime: string;
  timer: any;
  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.dateoffset(this.starttime, this.endtime);
    if (this.timerstop) {
      this.timerstop.subscribe(stop => {
        if (stop) {
          clearTimeout(this.timer);
        }
      });
    }
  }

  dateoffset(start, end) {

    if(start != null) {
      if (end === null) {
        this.timer = setInterval(() => {
          this.timeCalcul(start, end);
        }, 1000);
      } else {
          this.timeCalcul(start, end);
      }
    } else {
      this.pastTime = "00:00"
    }
    
  }

  timeCalcul(start, end) {
    // Get 1 day in milliseconds
    // let one_day=1000*60*60*24;
    const date1 = new Date(start);
    const date1_ms = date1.getTime();
    let date2: any;
    let date2_ms: any;
    if (end) {
      date2 = new Date(end);
      date2_ms = date2.getTime();
    } else {
      date2 = new Date();
      date2_ms = date2.getTime() + date2.getTimezoneOffset() * 3600 * 1000 / 60; // current UTC
    }
    // Calculate the difference in milliseconds
    let difference_ms = date2_ms - date1_ms;
    // take out seconds
    difference_ms = difference_ms / 1000;
    const seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    const minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    const hours = Math.floor(difference_ms % 24);
    const days = Math.floor(difference_ms / 24);

    // Format the time that has passed
    let str = '';

    if (hours > 0) {
      str += hours + ':';

      if (minutes < 10) {
        str += '0' + minutes;
      } else {
        str += minutes;
      }
    } else {
      str += minutes;
    }

    if (seconds < 10) {
      str += ':0' + seconds;
    } else {
      str += ':' + seconds;
    }
    if (days >= 1) {
      const strDays = 'days';
      // str = days + ' ' + strDays + ' ' + str;
      this.translate.get(strDays)
        .subscribe((res: string) => {
          str = days + ' ' + res + ' ' + str;
        });
    }
    this.pastTime = str;
    // if (this.title == 'Provider Arrival') {
    //   
    // }
  }
}
